import { Button, FormLabel, Modal, ModalDialog, Textarea, Divider } from '@mui/joy';
import React from 'react';

interface DynamicViewModalProps {
    isOpen: boolean;
    onClose: () => void;
    value: any;
}


const DynamicViewModal = ({ isOpen, onClose, value }: DynamicViewModalProps) => {
    return (
        <Modal open={isOpen} onClose={onClose}>
            <ModalDialog sx={{minWidth: "70%"}}>
                <h3>Details</h3>
                <Divider />
                <FormLabel sx={{ marginTop: "1rem", paddingBottom: "0.5rem" }}>{value.label}</FormLabel>

                <Textarea
                    name={value.label}
                    value={value.value}
                    minRows={5}
                />
            </ModalDialog>
        </Modal>
    );
}

export default DynamicViewModal;
